<template>
  <div class="settings container">
    <div class="box">
      <el-page-header @back="$router.go(-1)" content="发放设置">
      </el-page-header>
      <h3 class="task-name">{{ $route.query.examTitle }}</h3>
      <el-form
        :model="form"
        size="small"
        label-width="100px"
        label-position="left"
      >
        <el-form-item label="发放时间" style="line-height: 33px">
          <el-radio v-model="form.rightStart" :label="true">立即发放</el-radio>
          <el-radio v-model="form.rightStart" :label="false"
            >定时发放
            <el-date-picker
              v-show="!form.rightStart"
              v-model="form.startTime"
              type="datetime"
              placeholder="选择日期时间"
              style="margin-left: 10px"
              :picker-options="pickerOptions"
              default-time="00:00:00"
            >
            </el-date-picker
          ></el-radio>
        </el-form-item>
        <el-form-item label="截止时间">
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="选择日期时间"
            :picker-options="pickerOptions"
            default-time="00:00:00"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="makeUp" label="考试限时">
          <el-input-number
            v-model="form.duration"
            :min="0"
            :controls="false"
          ></el-input-number>
          分钟<el-tooltip
            class="item"
            style="margin-left: 10px"
            effect="dark"
            content="从学生进入答题页面开始倒计时，时间耗尽后学生无法继续作答"
            placement="top"
          >
            <i class="el-icon-info" style="color: #c0c4cc"></i>
          </el-tooltip>
        </el-form-item>
        <el-form-item prop="minSubmitTime" label="限时提交">
          <el-input-number
            v-model="form.minSubmitTime"
            :min="0"
            :controls="false"
          ></el-input-number>
          分钟内不允许提交
        </el-form-item>
        <el-form-item prop="maxJoin" label="限时进入">
          <el-input-number
            v-model="form.maxJoin"
            :min="1"
            :controls="false"
          ></el-input-number>
          分钟后不允许参加考试
        </el-form-item>
        <el-form-item label="防作弊设置">
          <el-checkbox v-model="form.questionDisorder">题目乱序</el-checkbox>
          <p class="tips" style="font-size: 12px; color: #909399">
            学生接收到的题目显示顺序不同
          </p>
        </el-form-item>
        <!-- 高级设置 -->
        <el-collapse v-model="activeNames" class="collapse">
          <el-collapse-item title="高级设置" name="1">
            <el-form-item prop="pass" label="及格标准">
              <el-input-number
                size="small"
                v-model="form.passScore"
                :controls="false"
              ></el-input-number
              ><span style="margin: 0 10px">分</span>
            </el-form-item>
            <el-form-item label="交卷设置">
              <el-checkbox v-model="form.autoSubmit"
                >考试到达截止时间后自动提交
              </el-checkbox>
            </el-form-item>
            <el-form-item label="重做设置">
              <div class="one-item">
                <el-checkbox v-model="form.redo">允许学生重考</el-checkbox>
                <el-input-number
                  style="margin: 0 10px"
                  size="small"
                  v-model="form.redoNum"
                  :controls="false"
                ></el-input-number
                >次
                <el-tooltip
                  class="item"
                  style="margin-left: 10px"
                  effect="dark"
                  content="最后一次考试成绩为最终成绩"
                  placement="top"
                >
                  <i class="el-icon-info" style="color: #c0c4cc"></i>
                </el-tooltip>
              </div>
            </el-form-item>

            <el-form-item label="试卷设置">
              <div class="one-item">
                <el-checkbox v-model="form.afterLookPaper"
                  >允许学生考后查看试卷</el-checkbox
                >
              </div>
              <div class="one-item" v-show="form.afterLookPaper">
                <el-select v-model="lookAnswer" placeholder="请选择">
                  <el-option label="不" :value="0"> </el-option>
                  <el-option label="学生提交后" :value="1"> </el-option>
                  <el-option label="考试截止后" :value="2"> </el-option>
                </el-select>
                允许查看答案
              </div>
              <div class="one-item">
                <el-checkbox v-model="form.lookScore"
                  >允许学生查看分数</el-checkbox
                >
              </div>
              <!-- <div class="one-item" v-show="form.lookScore">
                <el-checkbox v-model="form.lookTypeScore"
                  >允许学生查看题型分数</el-checkbox
                >
              </div>
              <div class="one-item">
                <el-checkbox v-model="form.canPaste"
                  >允许学生粘贴答案</el-checkbox
                >
              </div> -->
            </el-form-item>
          </el-collapse-item>
        </el-collapse>
      </el-form>
      <div class="btns">
        <el-button
          size="medium"
          type="primary"
          plain
          round
          @click="$router.go(-1)"
          >取消</el-button
        >
        <el-button size="medium" type="primary" round @click="handleSubmit"
          >发放</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { releaseExam, releaseExamInfo, editReleaseExam } from "@/api/exam";

export default {
  data() {
    return {
      form: {
        classId: this.$route.query.id,
        examId: this.$route.query.examId,
        name: "考试11111",
        rightStart: false,
        startTime: "",
        rightEnd: false,
        endTime: "",
        duration: 60,
        minSubmitTime: 10,
        maxJoin: undefined,
        questionDisorder: false,
        passScore: undefined,
        autoSubmit: true,
        redo: false,
        redoNum: undefined,
        afterLookPaper: true,
        lookScore: true,
        afterEndLookAnswer: false,
        afterSubmitLookAnswer: false,
        // lookTypeScore: false,
        // canPaste: false,
      },
      lookAnswer: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        },
      },
      activeNames: "",
    };
  },
  created() {
    let releaseId = this.$route.query.releaseId;
    releaseId && this.getInfo(releaseId);

    this.activeNames = releaseId ? "1" : "";
  },
  watch: {
    lookAnswer(val) {
      if (val == 0) {
        this.form.afterEndLookAnswer = false;
        this.form.afterSubmitLookAnswer = false;
      } else if (val == 1) {
        this.form.afterSubmitLookAnswer = true;
        this.form.afterEndLookAnswer = false;
      } else {
        this.form.afterSubmitLookAnswer = false;
        this.form.afterEndLookAnswer = true;
      }
    },
  },
  methods: {
    // 详情
    getInfo(releaseId) {
      this.$loading.show();
      releaseExamInfo(releaseId).then(({ code, data, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          for (let key in data) {
            if (JSON.stringify(data[key]) == "null") {
              data[key] = undefined;
            }
          }
          this.form = data;
          if (!data.afterEndLookAnswer && !data.afterSubmitLookAnswer) {
            this.lookAnswer = 0;
          } else if (data.afterSubmitLookAnswer) {
            this.lookAnswer = 1;
          } else {
            this.lookAnswer = 2;
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    handleSubmit() {
      this.$loading.show();
      (this.$route.query.releaseId ? editReleaseExam : releaseExam)(
        this.form
      ).then(({ code, msg }) => {
        this.$loading.hide();
        if (code == 0) {
          this.$message.success("发放成功");
          this.$router.replace({
            path: "/classCourse/exam",
            query: {
              id: this.$route.query.id,
              courseId: this.$route.query.courseId,
            },
          });
        } else {
          this.$message.error(msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.settings {
  height: 100%;
  text-align: left;

  .box {
    padding: 25px 35px;
    background-color: #fff;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }
    ::v-deep .el-page-header {
      .el-page-header__content {
        font-size: 16px;
      }
    }
    .task-name {
      margin: 20px 0;
      color: #303133;
    }
    ::v-deep .collapse {
      border: none;
      .el-collapse-item__wrap {
        border-bottom: none;
      }
      .el-collapse-item__header {
        display: inherit;
        border-bottom: none;
        color: #303133;
        font-weight: bold;
      }
    }
    .el-input-number {
      width: 60px;
    }
    ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
      color: inherit;
    }
    .el-select {
      width: 120px;
    }
    .one-item {
      margin-bottom: 10px;
    }
    .btns {
      margin-top: 10px;
      text-align: center;
      .el-button {
        margin-right: 30px;
        width: 100px;
      }
    }
  }
}
</style>